import { useModels } from "@/hooks/useModels";
import { EliteHero } from "@/components/home/EliteHero";
import { BoardRail } from "@/components/home/BoardRail";
import { InFocus } from "@/components/home/InFocus";
import { ScoutingCTA } from "@/components/home/ScoutingCTA";
import { ReelBanner } from "@/components/home/ReelBanner";

export default function Home() {
  const { models } = useModels();
  return (
    <main data-testid="home-page">
      <EliteHero models={models} />
      <BoardRail models={models} />
      <ReelBanner />
      <InFocus models={models} />
      <ScoutingCTA />
    </main>
  );
}
